export class FacebookAPIConfig {
  ApiKey:string;

  constructor(json:any) {
    if(json!=null) {
      this.ApiKey = json.ApiKey;
    }
  }

}
